export enum FormOperationKind {
  /// <summary>
  /// سند ابتدای دوره
  /// </summary>
  IsFirstVoucher = 1,
  // /// <summary>
  // /// انبار به انبار
  // /// </summary>
  // HasWarehouseTransfer = 2,
  /// <summary>
  /// فاکتور خرید
  /// </summary>
  IsPurchaseInvoice = 3,
  /// <summary>
  /// فاکتور برگشت از خرید
  /// </summary>
  IsReturnPurchaseInvoice = 4,
  /// <summary>
  /// سند خرید خدمت
  /// </summary>
  IsPurchaseService = 5,
  /// <summary>
  /// سند مصرف
  /// </summary>
  IsConsumptionVoucher = 6,
  /// <summary>
  /// سند ضایعات
  /// </summary>
  IsDamages = 7,
  /// <summary>
  /// انبار گردانی
  /// </summary>
  IsTakingOfInventory = 8,
  /// <summary>
  /// ارسال به انبار روزانه
  /// </summary>
  SendToInvDailyVoucher = 9,
  /// <summary>
  /// دریافت از فروش رستورانی
  /// </summary>
  ReceivedFromResturantSell = 10,
  // /// <summary>
  // /// دریافت از راهکاران
  // /// </summary>
  // ReceivedFromRahkaran = 11,
  // /// <summary>
  // /// ارسال به راهکاران
  // /// </summary>
  // SendToRahkaran = 12,
}
